// Analytics loading utility
// Replace these values with your actual analytics provider details

export const ANALYTICS_SCRIPT_SRC = "https://analytics.example.com/script.js";
export const ANALYTICS_SITE_ID = "forgiveness-labs";

let analyticsLoaded = false;
let analyticsScriptElement: HTMLScriptElement | null = null;

/**
 * Safely check if we're in a browser environment
 */
const isBrowser = (): boolean => {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
};

/**
 * Load the analytics script dynamically
 * Only call this after user has accepted analytics consent
 */
export const loadAnalytics = (): void => {
  if (!isBrowser()) return;
  if (analyticsLoaded) return;

  const script = document.createElement('script');
  script.src = ANALYTICS_SCRIPT_SRC;
  script.async = true;
  script.defer = true;
  script.setAttribute('data-site-id', ANALYTICS_SITE_ID);
  
  // Store reference for potential removal
  analyticsScriptElement = script;
  
  script.onload = () => {
    analyticsLoaded = true;
    console.log('[Analytics] Script loaded successfully');
  };

  script.onerror = () => {
    console.warn('[Analytics] Failed to load analytics script');
  };

  document.head.appendChild(script);
};

/**
 * Remove analytics script and clear any runtime tracking
 * Call this when user revokes consent
 */
export const unloadAnalytics = (): void => {
  if (!isBrowser()) return;

  // Remove the script element if it exists
  if (analyticsScriptElement && analyticsScriptElement.parentNode) {
    analyticsScriptElement.parentNode.removeChild(analyticsScriptElement);
    analyticsScriptElement = null;
  }

  analyticsLoaded = false;

  // Clear any global analytics objects (common patterns)
  // You may need to adjust this based on your analytics provider
  if ((window as any).analytics) {
    delete (window as any).analytics;
  }
  if ((window as any)._paq) {
    delete (window as any)._paq;
  }
  if ((window as any).plausible) {
    delete (window as any).plausible;
  }

  console.log('[Analytics] Unloaded and cleared');
};

/**
 * Check if analytics is currently loaded
 */
export const isAnalyticsLoaded = (): boolean => {
  return analyticsLoaded;
};
